<template>
	<v-app id="app">
		<router-view></router-view>
        <v-footer min-width="100%" padless class="primary white--text">
            <v-col cols="12" class="text-center">
                <small v-html="data.address"></small>
            </v-col>
        </v-footer>
		<v-overlay :value="data == {}" :opacity="1">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
		</v-overlay>
	</v-app>
</template>

<script>
import StorageMixin from './shared/StorageMixin'

export default {
	name: 'App',
	mixins: [ StorageMixin ],
	data: () => ({
		data:{}, userLoggedIn:false, headersSet:false
	}),
	created(){
		if(this.token) this.userLoggedIn = true
		
		this.$eventBus.$on('user_logged_in', token => {
			this.setToken(token)
			this.configureApiRequests()
			this.userLoggedIn = true
			this.$router.push('dashboard')
		})
		
		this.$eventBus.$on('user_log_out', () => {
			this.removeToken()
			this.userLoggedIn = false
			this.$router.push('/')
		})

		if(!this.headersSet){
			this.configureApiRequests()
			this.headersSet = true
		}

		this.getIndexData()
			.then(data => {
				this.$eventBus.$emit('index_page_loaded', data)
				this.data = data	
			})
	},
	methods: {
		configureApiRequests(){
			let self = this
			self.$api.interceptors.request.use(
				config => {
					if(self.token){
						config.headers.common["Authorization"] = `Token ${self.token}`
					}
					return config;
				},
				error => {
					return Promise.reject(error);
				}
			)

			self.$api.interceptors.response.use(
				response => {
					if (
						response.status === 200 ||
						response.status === 201 ||
						response.status === 204
					) {
						return Promise.resolve(response);
					} else {
						return Promise.reject(response);
					}
				},
				error => {
					if (error.response) {
						// redirect to index if not authorized
						if(error.response.status === 401){
							this.$router.push('/').then().catch(error => error)
							this.removeToken()
						}
					} else if (error.request) {
						console.log(error.request);
					} else {
						console('🤷‍♂️', error.message)
					}
					return Promise.reject(error.response);
				}
			);
		},
		getIndexData(){
			return new Promise((res, rej) => {
			this.$api.get('/index/')
				.then(data =>  res(data.data))
				.catch(err => {
					console.log(err, 'Failed to recieve index page data')
					rej(err)
				})
			})
		}
	}
}

</script>

<style lang="scss">
	html, body { overflow-x:hidden!important; }
	#app { min-height:100vh; }
	.accented { color:#ff1744 }
	.height-minus-navbar { min-height:calc(100vh - 140px)!important }
</style>
